import { useSettings } from "../context/SettingsContext";

const useCookieNoticeSettings = () => {
  const { settings } = useSettings();

  return settings?.cookieNotice ?? false;
};

export default useCookieNoticeSettings;
